<template lang="pug">
  router-view(v-bind="{...$props, ...$attrs}" v-on="$listeners")
</template>

<script>
export default {
  mounted() {
    const old_on = this.$on;
    this.$on = (...args) => {
      old_on.apply(this, args);
    };
  },
};
</script>